import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, distinctUntilChanged, map, filter, tap, takeWhile } from 'rxjs/operators';
import { clientConfig } from 'src/client-config';
import { API_BASE_URL } from '../services/api.services';
import { GenericAlertData, GenericAlertDialog } from '../shared/dialogs';
import { createAppError } from '../shared/utils';
import { AppActions } from '../state/app';
import { AuthService } from './auth.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  unauthorized = false;

  constructor(
    private readonly authService: AuthService,
    private readonly dialog: MatDialog,
    private readonly store: Store) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const accessToken = this.authService.accessToken;

    if (accessToken) {
      request = request.clone({
        body: request.body,
        url: request.url,
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
          // 'Cache-Control': 'no-cache',
          // 'Pragma': 'no-cache',
          // 'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        }
      });
    }

    const processRequest = () => next.handle(request).pipe(
      catchError(err => this.handleErrorResponse(err))
    );

    return processRequest();
  }

  private handleErrorResponse(err: HttpErrorResponse): Observable<any> {
    if (err.status == 401) {
      if (err.url.startsWith(clientConfig.apiBaseUrl)) {
        // onUnauthorized is only called for Insights APIs
        // this.onUnauthorized(err);
      }
    }

    return throwError(createAppError(err, { preventSnack: this.unauthorized }));
  }

  private onUnauthorized(err: any) {
    if (this.unauthorized)
      return;

    this.unauthorized = true;

    this.store.dispatch(AppActions.unauthorized({ error: err }));
  }
}
